import { render, staticRenderFns } from "./CaixaLegenda.vue?vue&type=template&id=1dddc785&scoped=true"
import script from "./CaixaLegenda.vue?vue&type=script&lang=js"
export * from "./CaixaLegenda.vue?vue&type=script&lang=js"
import style0 from "./CaixaLegenda.vue?vue&type=style&index=0&id=1dddc785&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dddc785",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDivider,VIcon})
